import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the user interface based on the AuthResponse
interface User {
  _id: string;
  email: string;
  displayName?: string;
  role: string;
  language?: string; // User's preferred language (ISO 639-1 code)
}

// Define the user state interface
interface UserState {
  user: any;
  accessToken: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  initialized: boolean;
}

// Initial state
const initialState: UserState = {
  user: null,
  accessToken: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  initialized: false
};


// Create the user slice
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // Set loading state
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    // Set error state
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },

    // Set initialized state
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.initialized = action.payload;
    },

    // Login success
    loginSuccess: (state, action: PayloadAction<{ user: User; accessToken: string }>) => {

      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      state.initialized = true;

    },

    // Logout
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.error = null;
      // Keep initialized as true since we know the state
      state.initialized = true;
    },

    // Update user
    updateUser: (state, action: PayloadAction<Partial<User>>) => {

      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    }
  },
});

// Export actions
export const {
  setLoading,
  setError,
  setInitialized,
  loginSuccess,
  logout,
  updateUser
} = userSlice.actions;

// Export reducer
export default userSlice.reducer; 